import script from "./ExpenseSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseSummary.vue?vue&type=script&setup=true&lang=js"

import "./ExpenseSummary.vue?vue&type=style&index=0&id=561b9d13&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561b9d13"]])

export default __exports__